import type { ExerciseKind, FirstCardNote, TrainingResult } from '../model';
import { SessionScreen } from './SessionScreen';

interface SessionProps {
  onExit: () => void;
  /** Совместимость со старыми входами в тренировку. */
  cram?: boolean;
  /** Модуль cram-сессии (для резюма по cram-дорожке, она per-module). */
  moduleId?: string;
  /** Выход после просмотра результатов. */
  onFinish?: () => void;
  /** Свой экран итогов вместо Completion (знакомство). */
  onComplete?: (result: TrainingResult) => void;
  /** Подсказка до первого ответа (знакомство) — по виду упражнения первой карточки. */
  firstCardNote?: FirstCardNote;
  /** Первая карточка — этим упражнением (знакомство: выбор из вариантов). */
  firstExercise?: ExerciseKind;
}

/** Десктопная тренировка. Тонкая обёртка над общим SessionScreen —
 *  вся логика в useSessionEngine, мобильный вариант — MobileSession. */
export function Session({ onExit, cram, moduleId, onFinish, onComplete, firstCardNote, firstExercise }: SessionProps) {
  return (
    <SessionScreen
      onExit={onExit}
      variant="desktop"
      cram={cram}
      moduleId={moduleId}
      onFinish={onFinish}
      onComplete={onComplete}
      firstCardNote={firstCardNote}
      firstExercise={firstExercise}
    />
  );
}
